import get from 'lodash/get';
import store from "@app2/store";
import { hasPermission } from '@app2/utils/filters';

export const onboardGuard = async (to, from, next) => {
    // Get necessary information from the user and the store
    const activeSubscription = store.getters['auth/GET_SUBSCRIPTION'];
    const user = store.getters['auth/GET_USER'];
    const isOnboard = get(user, 'is_onboard', false);

    // Check if user requires email OTP verification first
    if (get(user, 'meta.requires_email_otp', false) && to.name !== 'VerifyOtp') {
        next({ name: 'VerifyOtp' });
        return;
    }

    if ( isOnboard || !activeSubscription ) {
        next();
        return;
    }

    // Determine the appropriate route based on existence of hub
    if (!hasPermission('hubs', user, { existsOnly: true })) {
        next({ name: 'OnboardingCreate' });
    } else {
        // Onboard user, allow navigation to the target route
        await store.dispatch('auth/updateOnboarding', {
            name: user.name,
            onboard_step: 2,
            is_onboard: 1,
        });
        next();
    }
};